import { createContext, useContext } from 'react';

import type { KeyboardEngine } from './keyboard-engine';

export interface KeyboardEngineContextValue {
  readonly engine: KeyboardEngine;
}

export const KeyboardEngineContext = createContext<KeyboardEngineContextValue | null>(null);

export function useKeyboardEngineContext(): KeyboardEngineContextValue {
  const ctx = useContext(KeyboardEngineContext);
  if (!ctx) {
    throw new Error(
      '[KeyboardEngine] useKeyboardEngineContext must be used within KeyboardEngineProvider.',
    );
  }
  return ctx;
}
